import {Stack, Typography} from '@mui/material';
import Tutorial from 'presentation/components/Tutorial';
import {translations} from 'presentation/translations-new';
import React from 'react';
import type {Placement, Step} from 'react-joyride';
import {TutorialStepsId, type RenderContentProps, type TherapyTutorialsProps} from './types';

const {addSession, addMultipleSessions, additionalActions, variousTherapies} =
	translations['pt-br'].privateFlow.refund.therapies.tutorials;

export const TherapyTutorials = ({step}: TherapyTutorialsProps) => {
	const renderContent = ({title, description}: RenderContentProps) => (
		<Stack>
			<Typography variant="subtitle1" fontWeight={600}>
				{title}
			</Typography>
			<Typography variant="body2">{description}</Typography>
		</Stack>
	);

	const renderSteps = (): Step[] => {
		switch (step) {
			case 'initial':
				return [
					{
						target: `#${TutorialStepsId.FORM_SESSIONS}`,
						content: renderContent({
							title: addSession.title,
							description: addSession.description,
						}),
						placement: 'top-end' as Placement,
						disableBeacon: true,
					},
					{
						target: `#${TutorialStepsId.FORM_ADD_SESSION}`,
						content: renderContent({
							title: addMultipleSessions.title,
							description: addMultipleSessions.description,
						}),
						placement: 'top-end' as Placement,
						disableBeacon: true,
					},
				];
			case 'edit':
				return [
					{
						target: `#${TutorialStepsId.FORM_SESSIONS}`,
						content: renderContent({
							title: additionalActions.title,
							description: additionalActions.description,
						}),
						placement: 'top-end' as Placement,
						disableBeacon: true,
					},
				];
			case 'addSessions':
				return [
					{
						target: `#${TutorialStepsId.ADD_SESSIONS}`,
						content: renderContent({
							title: variousTherapies.title,
							description: variousTherapies.description,
						}),
						placement: 'top-end' as Placement,
						disableBeacon: true,
					},
				];
			default:
				return [];
		}
	};

	const renderStorageKey = () => {
		switch (step) {
			case 'initial':
				return '@hapvida:refund-therapy-sessions-tutorial';
			case 'edit':
				return '@hapvida:refund-therapy-edit-sessions-tutorial';
			case 'addSessions':
				return '@hapvida:refund-therapy-add-sessions-tutorial';
			default:
				return '@hapvida:refund-therapy-sessions-tutorial';
		}
	};

	return (
		<Tutorial
			steps={renderSteps()}
			storageKey={renderStorageKey()}
			customButtonsLabels={{last: 'Entendi', next: 'Próximo'}}
			customContainerWidth={`328px`}
			disableScrollParentFix={false}
		/>
	);
};
